var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error" }, [
    _c(
      "div",
      [
        _c("p", [
          _vm._v(_vm._s(_vm._f("trans")("errors." + _vm.error + ".title")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "cat" }, [
          _c("small", [_vm._v(_vm._s(_vm._f("trans")("errors.cat")))])
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          { staticClass: "btn lg", attrs: { to: { name: "dashboard" } } },
          [_vm._v("\n      " + _vm._s(_vm._f("trans")("home")) + "\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36c62c42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c62c42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Error.vue
// module id = null
// module chunks = 